// extracted by mini-css-extract-plugin
export default {"ActionsContainer":"Apps_ActionsContainer__Obz2z"};